export const no = {
    admin: {
        user: 'Kundemodusvisning',
        userModeDescription:
            'Ved å aktivere denne modusen vil siden forhåndsvises slik den blir presentert for kundene.',
    },
    app: {
        forvalter: 'Eiendomsdashbord',
        mittleieforhold: 'Mitt leieforhold',
        openInSuperOffice: 'SuperOffice',
        verified: 'Verified',
        d365: 'Dynamics 365',
        eiendomGpt: 'EiendomGPT',
    },
    auth: {
        authorizing: 'Logger inn...',
        loggingOut: 'Logger ut...',
        login: 'Logg inn',
        logout: 'Logg ut',
        privacyDescription:
            'Ved å bruke denne siden godtar du at vi samler informasjon som brukes til å forbedre ' +
            'brukeropplevelsen for brukerne av denne siden. Les om behandlingen av personopplysninger i Mitt leieforhold i vår ',
        privacyLinkTitle: 'personvernerklæring.',
        sessionTimeout: 'Din sesjon har utløpt',
        sessionTimeoutLoginAgain: 'Vennligst logg inn på nytt',
    },
    breadcrumbs: {
        building: 'Eiendom',
        byggUtleie: 'Utleie',
        contract: 'Kontrakter',
        dashboard: 'Mitt Leieforhold',
        invoice: 'Faktura',
        listUsers: 'Brukere',
        message: 'Oppslagstavle',
        registerUser: 'Registrer bruker',
        searchUsers: 'Søk etter brukere',
        selectClient: 'Velg kundeforhold',
        supportApplicationForm: 'Søknad om støtte',
        ticket: 'Saker',
    },
    buildingClientChooser: {
        groupByBuilding: 'Gruppér etter eiendom',
        groupByClient: 'Gruppér etter kunde',
        recipients: {
            all: 'Alle mottakere',
            search: 'Søk mottakere',
            select: 'Mottakere',
            selected: 'Utvalgte mottakere',
        },
    },
    bygg: {
        activeClients: 'Aktive kunder',
        adresse: 'Adresse',
        andelFossilEl: 'Andel fossil/el',
        arealType: 'Type',
        backToOverview: 'Tilbake til eiendomsoversikten',
        backToOverviewForClient:
            'Tilbake til eiendomsoversikten for {{customerName}}',
        beskrivelse: 'Om eiendommen',
        bygg: 'Eiendom',
        byggeAar: 'Byggeår',
        byggInfo: {
            numberOfBuildings: '{{count}} eiendommer',
            numberOfBuildings_1: '{{count}} eiendom',
            numberOfContracts: '{{count}} avtaler',
            numberOfContracts_1: '{{count}} avtale',
        },
        byggListTitle: 'Mine Eiendommer',
        byggListTitleAdmin: 'Eiendom for {{customerName}} ({{customerNumber}})',
        byggListTitleAdminAllBuildings: 'Alle eiendommer',
        byggNummer: 'Byggnummer',
        byggSearch: 'Søk Eiendom',
        contractDetails: 'Økonomi',
        customers: 'Kunder',
        documents: 'Dokumenter og tegninger',
        driftsAnsvarlig: 'Driftssjef',
        driftsTekniker: 'Driftstekniker',
        eiendomsAnsvarlig: 'Eiendomssjef',
        eiendomsNummer: 'Eiendomsnummer',
        energiForbruk: 'Beregnet energiforbruk',
        energiKarakter: 'Energikarakter',
        errorList: {
            description: 'Noe gikk galt ved lasting av eiendommer.',
            title: 'Noe gikk galt ved lasting av eiendommer.',
        },
        errorNoClients: {
            title: 'Ingen kunder for dette bygget.',
        },
        errorNotFound: {
            description: 'Ingen eiendommer funnet.',
            title: 'Ingen eiendommer funnet.',
        },
        errorSingle: {
            description: 'Noe gikk galt ved lasting av eiendomen.',
            title: 'Noe gikk galt ved lasting av eiendomen.',
        },
        etasjer: 'Etasjer',
        forbruk: 'Miljøprofil',
        futureClients: 'Kommende kunder',
        gabNummer: 'GAB-nummer',
        inactiveClients: 'Inaktive kunder',
        kompleksNummer: 'Kompleksnummer',
        name: 'Navn',
        overview: 'Oversikt',
        searchDocument: {
            placeholder: 'Skriv ditt søkeord her',
            title: 'Søk i tegninger',
        },
        showAll: 'Vis alle eiendommer',
        tickets: 'Saker',
        totAreal: 'Totalt areal',
        shortcut: 'Snarvei',
    },
    byggCalendar: {
        name: 'Kalender',
        error: {
            title: 'Noe gikk galt',
            description:
                'Vi har problemer med å vise kalenderen for denne eiendommen akkurat nå. Prøv igjen om en liten stund.',
        },
    },
    byggDokument: {
        errorDownload: {
            description: 'Noe gikk galt ved lasting av tegninger.',
            title: 'Noe gikk galt ved lasting av tegninger.',
        },
        errorNotFound: {
            description:
                'Vi fant ingen dokumenter eller tegninger knyttet til ditt bygg.',
            title: 'Ingen tegninger funnet.',
        },
        tableTitle: {
            generalInfo: 'Generell informasjon',
            contractAttachment: 'Kontraktsvedlegg',
            fire: 'Brann',
            escape: 'Rømning',
        },
        etasje: 'Etasje',
        maalestokk: 'Målestokk',
        navn: 'Navn',
        nummer: 'Nummer',
        revdato: 'Revisjon',
    },
    byggUtleie: {
        areaAvailable: 'Ledig areal',
        areaLeased: 'Utleid areal',
        areaRatio: 'Arealmessig utleiegrad',
        areaToExpire: 'Utløpende areal',
        available: 'Ledig',
        econRatio: 'Økonomisk utleiegrad',
        expires: 'Utløper',
        expiring: 'Kontrakter til utløp',
        leased: 'Utleid',
        menu: 'Utleie',
        title: 'Eiendom utleie',
        vacant: 'Ledige lokaler per {{from}}:',
    },
    clientSelect: {
        chooseClient: 'Velg kundeforhold',
        clientName: 'Kundenavn',
        clientNumber: 'Kundenummer',
        clientLastActiveInML: 'Sist aktiv i Mitt Leieforhold',
        errorNoClients: {
            description: 'Ta kontakt med oss for å løse dette.',
            title: 'Du har ingen aktiv kundeforhold.',
        },
        errorNoClientsSelected: {
            description: 'For å se data må du velge ditt kundeforhold først.',
            title: 'Ingen kundeforhold valgt.',
        },
        notFound: 'Ingen kunder funnet.',
        searchClient: 'Søk kunde',
        selectAktiveOnly: 'Søk kun i kunder med aktive kontrakter',
        selectedClient: 'Valgt kunde: {{customerName}}',
        welcomeMessageSent: 'Velkomstmelding sendt',
    },
    contractManagement: {
        title: 'Kontrakter',
        leko: 'Forhandlinger',
        avtaler: 'Mine avtaler',
    },
    contractFrame: {
        externalFrame: {
            actionButton: 'Åpne kontraktsforhandling',
            contractNotFoundDescription:
                'Du kan finne alle dine gjeldende leiebetingelser under den respektive eiendomen',
            contractNotFoundLink: 'Gå til mine eiendommer',
            contractNotFoundTitle: 'Ser du etter dine leiebetingelser?',
            manualContractDescription:
                'Du kan få en kopi av dine kontrakter ved å kontakte din eiendomssjef hos KLP',
            manualContractTitle: 'Ser du etter en eksisterende PDF kontrakt?',
            description:
                'For å åpne kontraktsforhandlingen, må vi bruke en ny fane',
            title: 'Skal du signere eller forhandle en ny kontrakt?',
        },
    },
    dxboFrame: {
        externalFrame: {
            actionButton: 'Åpne Beslutningsportal',
            description:
                'For å åpne beslutningsportalen - hvor du kan gjøre tilpasninger til ditt nye lokale, må vi bruke en ny fane',
            title: 'Skal du tilpasse ditt nye lokale?',
        },
    },
    leaseAgreement: {
        table: {
            property: 'Eiendom',
            propertyNumber: 'Eiendom Nr.',
            propertyName: 'Eiendom',
            name: 'Navn',
            quantity: 'Areal',
            leaseFromDate: 'Fra',
            leaseToDate: 'Til',
            contractNumber: 'Kontrakt Nr.',
            notFound: 'Ingen avtaler funnet.',
        },
        title: 'Mine avtaler',
        activeAgreement: 'Aktive avtaler',
        archivedAgreement: 'Utgåtte avtaler',
        futureAgreement: 'Kommende avtaler',
        errorDownload: {
            description: 'Noe gikk galt ved lasting av avtaler.',
            title: 'Noe gikk galt ved lasting av avtaler.',
        },
    },
    environment: {
        description:
            'Denne tjenesten kan være ustabil i noen perioder.' +
            'Vi utvikler og forbedrer den kontinuerlig og vi setter stor pris på alle dine tilbakemeldingene og forslag.',
        dev: 'DEV',
        environment: 'Miljø: ',
        local: 'LOCAL',
        test: 'TEST',
    },
    faktura: {
        amount: 'Beløp',
        betalingsgrad: 'Betalingsgrad',
        inkasso: 'Inkasso',
        purring: 'Purring',
        delayed: 'Forsinket',
        delayedPayments: 'Forsinket betalinger',
        delayedPayments_0: 'Forsinket betaling',
        dueDate: 'Forfall',
        errorDownload: {
            description: 'Noe gikk galt ved lasting av fakturaer.',
            title: 'Noe gikk galt ved lasting av fakturaer.',
        },
        errorNotFound: {
            description: 'Ingen fakturaer funnet.',
            title: 'Ingen fakturaer funnet.',
        },
        emptyTable: 'Ingen fakturaer matcher søket ditt',
        faktura: 'Fakturaer',
        faktura_1: 'Faktura',
        fakturaNumber: 'Nr.',
        incomingPayments: 'Kommende betalinger',
        incomingPayments_0: 'Kommende betaling',
        invoiceNumberShort: 'Nr',
        invoicesFor: 'Fakturaer for {{kundeName}} ({{kundeNummer}})',
        invoiceSummary: 'Sum: {{sum}}kr hvorav forsinket: {{delayed}}kr',
        issueDate: 'Fakturadato',
        lastpaymentdate: 'Sist innbetalt',
        left: 'Utestående',
        myInvoices: 'Mine fakturaer',
        notSettledInvoices: 'Ubetalte faktura',
        notSettledInvoices_1: 'Ubetalt faktura',
        paid: 'Innbetalt',
        payments: 'Betalinger',
        refunds: 'Kreditnotaer',
        refunds_0: 'Kreditnota',
        settledInvoice_0: 'Betalt faktura',
        settledInvoices: 'Betalte fakturaer',
        status: 'Status',
    },
    fakturaStatus: {
        AwaitingPayment: 'Skal betales',
        AwaitingRefund: 'Skal refunderes',
        Refunded: 'Refundert',
        Paid: 'Betalt',
        PartiallyPayed: 'Delbetalt',
        Overdue: 'Forfalt',
        Unknown: 'Ukjent',
    },
    file: {
        deleting: 'Sletter filene...',
        deleting_1: 'Sletter filen...',
        downloading: 'Laster ned...',
        fileNotFound: 'Filen finnes ikke',
        preview: 'Visning',
        previewDownload: 'Visning    / Last ned',
        saving: 'Lagrer filene...',
        saving_1: 'Lagrer filen...',
        selectFiles: 'Velg filer',
        selectFiles_0: 'Velg fil',
        downloadFailed: 'Nedlasting mislyktes',
        downloadSuccess: 'Filen er lastet ned',
    },
    footer: {
        contactIntro: 'Vi hjelper deg',
        email: {
            prefix: 'E-post: ',
            text: 'Skriv til oss',
            url: {
                no: 'mailto:kundeogmiljosenter@klpeiendom.no',
                en: 'mailto:kundeogmiljosenter@klpeiendom.no',
                sv: 'mailto:info@klpfastigheter.se',
                da: 'mailto:kbh@klp.no',
            },
        },
        openingHours: {
            no: 'Døgnbemannet',
            en: 'Døgnbemannet',
            sv: 'Døgnbemannet',
            da: 'Bemannet i kontortiden',
        },
        phone: {
            prefix: 'Døgnåpen telefon: ',
            no: {
                title: '23 08 08 14',
                url: 'tel:+4723080814',
            },
            en: {
                title: '23 08 08 14',
                url: 'tel:+4723080814',
            },
            sv: {
                title: '08-657 77 56',
                url: 'tel:+4686577756',
            },
            da: {
                title: '(+45) 70 26 26 61',
                url: 'tel:+4570262661',
            },
        },
        privacy: {
            description: 'Personvern, klageadgang og sikkerhet',
            url: {
                no: 'https://www.klpeiendom.no/oslo/om-klp-eiendom/personvern',
                en: 'https://www.klpeiendom.no/oslo/om-klp-eiendom/personvern',
                sv: 'https://www.klpfastigheter.se/stockholm/om-oss/personuppgifter',
                da: 'https://www.klpejendomme.dk/kobenhavn/om-os/persondatapolitik',
            },
        },
        newSak: {
            text: 'Registrer ny sak',
            link: 'https://mittleieforhold.klpeiendom.no/sak/add',
        },
    },
    frontPage: {
        accountSettings: 'Kontoinnstillinger',
        buildings: 'Eiendom',
        buildingsLink: 'Mine eiendommer',
        contract: 'Kontrakter',
        contractManagement: {
            subtitle: 'Forhandle ny kontrakt?',
            contractNegotiation: 'Kontraktsforhandling',
        },
        dxboProject: 'Beslutningsportal',
        frontpage: 'Forsiden',
        invoice: {
            title: 'Faktura',
            invoiceLink: 'Mine faktura',
            sumOutstanding: 'Utestående beløp: ',
            outstandingInvoiceCount: 'Faktura {{outstandingInvoiceCount}} stk',
            outstanding: 'Utestående',
        },
        messages: 'Oppslagstavle',
        messagesLink: 'Se alle meldinger',
        mytasksLink: 'Saksoversikt',
        errorReporting: 'Feilrapport',
        newsFeed: {
            title: 'Siste fra KLP Eiendom:',
            linkText: 'Se alt fra KLP Eiendom på LinkedIn',
        },
        twoFactorAlertText: 'Tofaktor autentisering tilgjengelig',
        boldTwoFactorAlertText: ' - Aktiveres i Kontoinnstillinger!',
        welcome: {
            mittleieforhold: 'Velkommen til Mitt Leieforhold',
            forvalter: 'Velkommen til Eiendomsdashbord',
            yourAdminDashboard: 'Velkommen til ditt Eiendomsdashbord{{name}}',
        },
        miljo: {
            title: 'Miljø',
        },
        sustainability: {
            title: 'Bærekraft',
        },
        miljoprofil: {
            title: 'Byggets miljøprofil',
        },
    },
    editor: {
        paragraph: 'Avsnitt',
        heading1: 'Overskrift 1',
        heading2: 'Overskrift 2',
        heading3: 'Overskrift 3',
        heading4: 'Overskrift 4',
        heading5: 'Overskrift 5',
        heading6: 'Overskrift 6',
        horizontalRule: 'Horisontal linje',
        insertTable: 'Sett inn tabell',
        loadingEditor: 'Laster editor...',
        addColumnBefore: 'Ny kolonne før',
        addColumnAfter: 'Ny kolonne etter',
        deleteColumn: 'Slett kolonne',
        addRowBefore: 'Ny rad før',
        addRowAfter: 'Ny rad etter',
        deleteRow: 'Slett rad',
        deleteTable: 'Slett tabell',
    },
    general: {
        adminContent: 'Denne vises kun for adminbrukere',
        backToTop: 'Tilbake til toppen',
        by: 'av',
        cancel: 'Avbryt',
        clear: 'Tøm',
        clearList: 'Tøm listen',
        clearSelection: 'Fjern valget',
        close: 'Lukk',
        confirm: 'Ja',
        days: 'dager',
        days_0: 'dag',
        decline: 'Nei',
        delete: 'Slett',
        details: 'Detaljer',
        download: 'Last ned',
        draft: 'Utkast',
        edit: 'Redigér',
        emptyList: 'Listen er tom',
        successfulOperation: 'Handlingen ble utført vellykket.',
        error: 'Feil',
        errorMessage: 'Det oppstod en feil. \n Vennligst prøv igjen senere.',
        expired: 'Utløpt',
        goBack: 'Gå tilbake',
        goBackToFrontpage: 'Gå tilbake til forsiden',
        loading: 'Laster...',
        deleting: 'Sletter...',
        menu: 'Meny',
        month: 'Måned',
        month_0: 'Jan',
        month_1: 'Feb',
        month_2: 'Mar',
        month_3: 'Apr',
        month_4: 'Mai',
        month_5: 'Jun',
        month_6: 'Jul',
        month_7: 'Aug',
        month_8: 'Sep',
        month_9: 'Okt',
        month_10: 'Nov',
        month_11: 'Des',
        noIe:
            'Vi beklager, men denne funksjonen støttes ikke i Internet Explorer. ' +
            'Vi anbefaler å bruke Google Chrome eller Mozilla Firefox-nettleseren.',
        of: 'av',
        open: 'Åpne',
        outdatedBrowser: {
            description:
                'Kjære bruker! Nettleseren din er utdatert og noen av funksjonalitetene kan fungerer feil. Vi anbefaler å bruke Google Chrome eller Mozilla Firefox-nettleseren.',
            title: 'Utdatert nettleser',
        },
        pageNotFound: 'Fant ikke siden',
        preview: 'Vis',
        previewDownload: 'Vis / Last ned',
        publish: 'Publisér',
        readMore: 'Les mer',
        reload: 'Last inn på nytt',
        reset: 'Nullstill',
        save: 'Lagre',
        saveAsDraft: 'Lagre som utkast',
        saved: 'Lagring vellykket',
        saving: 'Lagrer...',
        show: 'vis',
        showAll: 'Vis alle',
        submit: 'Send inn',
        sum: 'sum',
        updating: 'Oppdaterer...',
        wrote: 'skrev',
    },
    kontrakt: {
        agreements: 'kontrakter',
        agreements_1: 'kontrakt',
        agreementRows: 'rader',
        agreementRows_1: 'rad',
        antall: 'Størrelse',
        antenne: 'Antenne',
        'annet uten fellesar': 'Annet uten fellesareal',
        arkiv: 'Arkiv',
        arligEiendomskatt: 'Årlig eiendomsskatt',
        arligFellesKostnad: 'Årlige felleskostnader',
        arligLeie: 'Årlig leie',
        bod: 'bod',
        bolig: 'Bolig',
        butikk: 'Butikk',
        'bygg felles': 'felles bygning',
        coworking: 'Coworking',
        energiForbrukPrM2: 'Energiforbruk per m²',
        errorContractNotFound: {
            description: 'Det finnes ingen kontrakter for denne eiendommen.',
            title: 'Ingen kontrakter funnet.',
        },
        errorDownload: {
            description: 'Noe gikk galt ved nedlasting av kontrakter.',
            title: 'Noe gikk galt ved nedlasting av kontrakter.',
        },
        felles: 'Felles',
        felleskostnaderPrM2: 'Felleskostnader pr m²',
        festetomter: 'Festetomter',
        forretning: 'Forretning',
        'forretning uten fel': 'Forretning uten fellesareal',
        fra: 'Fra',
        garasje: 'Garasje',
        'garasje uten felles': 'Garasje uten fellesareal',
        gyldigFra: 'Gyldig fra',
        gyldigTil: 'Gyldig til',
        hotell: 'Hotell',
        'kantine areal': 'Kantineareal',
        kantine: 'Kantine',
        kontor: 'Kontor',
        kontrakt: 'Kontrakt',
        kontraktAgreements: 'Kontrakter',
        kontraktAgreementsActive: 'Aktive kontrakter',
        kontraktAgreementsInfobox:
            'Denne siden viser bare aktive kontrakter. Full oversikt og nedlastinger ligger i ',
        kontraktFra: 'Kontrakt fra',
        kontraktNummer: 'Kontraktnummer',
        kontraktsdato: 'Kontraktsdato',
        kontraktsnummer: 'Kontraktsnummer',
        kontraktTil: 'Kontrakt til',
        kontraktGaranti: 'Garanti',
        kostPrPplassPrAr: 'Kostnad per p-plass per år',
        lager: 'Lager',
        'lager uten fellesar': 'Lager uten fellesareal',
        m2: 'm²',
        unknownFileName: 'ukjent filnavn',
        navn: 'Navn',
        other: 'Annet',
        parkering: 'Parkering',
        pcs: 'stk.',
        pris: 'Pris',
        prisPerAar: 'Årspris',
        perAar: '/år',
        perM2: '/m²',
        perStk: '/stk.',
        pricePerUnit: 'Enhetspris',
        reklameplass: 'Reklameplass',
        relatedFiles: 'Relaterte filer',
        restaurant: 'Restaurant',
        servering: 'Servering',
        showFiles: 'Vis filer',
        teknisk: 'Teknisk',
        'teknisk uten felles': 'Teknisk uten fellesareal',
        til: 'Til',
        fristOppsigelseLeietaker: 'Tidligst mulig dato for oppsigelse',
        tomt: 'Tomt',
        totaltAreal: 'Totalareal',
        'trening uten felles': 'Trening uten fellesareal',
        verksted: 'Verksted',
        undervisning: 'Undervisning',
        uteservering: 'Uteservering',
    },

    languageName: 'Norsk',
    listUsers: {
        adminUserExplanation:
            'Adminbruker har full tilgang til alle data. Kun KLP-brukere kan være admin brukere.',
        notRegisteredInSuperOfficeWarning: {
            description:
                'For at du skal kunne se eller registrere brukere for denne kunden må kunden først registreres i SuperOffice',
            superOfficeButtonText: 'Åpne SuperOffice',
            title: 'Denne kunden er ikke registrert i SuperOffice',
        },
        superUserExplanation:
            'Superbruker har tilgang til kontrakter og fakturaer. NB! Kunden kan bestemme selv å gi superbruker-tilgang til andre brukere i organisasjonen.',
        superUserExplanationForUser:
            'Superbruker har tilgang til kontrakter og fakturaer. Du kan bestemme selv å gi superbruker-tilgang til andre brukere i din organisasjon.',
        title: 'Brukere',
        usersForCustomer: 'Brukere for {{customer}}',
    },
    message: {
        actions: {
            Deleted: 'Slett',
            Draft: 'Utkast',
            Expired: 'Sett utløpt',
            Published: 'Publisér',
            WillPublish: 'Sett publisering',
            sendCopyToMe: 'Send e-postvarsel til meg',
        },
        action: 'Handling',
        addMessage: 'Ny melding',
        allMessages: 'Alle meldinger',
        backButton: 'Tilbake til meldingsoversikten',
        download: 'Last ned oppslaget',
        category: {
            helperText: 'Velg meldingstype',
            name: 'Type',
        },
        categoryType: {
            Alert: 'Kritisk',
            Info: 'Info',
            Warning: 'Varsel',
        },
        channel: {
            confirmEmail:
                'Alle mottakere vil få e-postvarsel. Vil du sende det?',
            email: 'Send som e-post',
            infoText: 'Utsendelsen av e-posten gjøres i løpet av natten.',
            yes: 'Ja, send',
            notificationSent: 'Varsel sendt til mottakere {{timeSent}}',
            sendTonight: 'Send i kveld/natt',
            sendImmediately: 'Send umiddelbart',
        },
        content: {
            helperText: 'Skriv inn din melding',
            name: 'Melding',
        },
        dialog: {
            Deleted: {
                action: 'Ja, slett meldingen',
                description: 'Vil du slette meldingen?',
                title: 'Slett meldingen',
            },
            Draft: {
                action: 'Ja, sett som utkast',
                description: 'Vil du endre status på meldingen til utkast?',
                title: 'Sett som utkast',
            },
            Expired: {
                action: 'Ja, sett som utløpt',
                description: 'Vil du endre status på meldingen til utløpt?',
                title: 'Utløpt melding',
            },
            Published: {
                action: 'Ja, publisér',
                description: 'Vil du publisere meldingen?',
                title: 'Publisér meldingen',
            },
        },
        editMessage: 'Redigér melding',
        errorNoMessagesFound: {
            description: 'Du har ingen meldinger akkurat nå.',
            title: 'Du har ingen meldinger akkurat nå.',
        },
        expiresAt: {
            helperText: 'Velg utlopsdato eller la feltet stå tomt',
            name: 'Utløpsdato',
        },
        importantMessages: 'Viktige meldinger',
        isPinned: {
            helperText: 'Du kan fremheve meldingen på nyhetsstrømmen',
            name: 'Pin meldingen',
        },
        messageDocuments: {
            helperText:
                'Du kan markere filer for sletting eller laste opp flere filer',
            name: 'Tegninger',
        },
        messageImages: {
            helperText:
                'Du kan markere bilder for sletting eller laste opp flere bilder',
            name: 'Bilder',
        },
        messagePinned: 'Denne meldingen er framhevet',
        messagesFor: 'Meldinger for {{kundeName}} ({{kundeNummer}})',
        messageStatus: 'Status',
        myMessages: 'Mine meldinger',
        publishAt: {
            helperText: 'Velg publiseringsdato',
            name: 'Publiseringsdato',
        },
        published: 'Publisert',
        readMore: 'Les hele saken',
        seeAll: 'Les alle meldingene',
        status: {
            Deleted: 'Slettet',
            Draft: 'Utkast',
            Expired: 'Utløpt',
            Published: 'Publisert',
            WillPublish: 'Skal publiseres',
        },
        title: {
            helperText: 'Skriv inn tittelen',
            name: 'Tittel',
        },
        updated: 'Oppdatert',
        // deprecated
        uploadedFiles: {
            helperText: 'Du kan markere filer for sletting',
            name: 'Opplastede filer',
        },
        // deprecated
        uploadFiles: {
            helperText: 'Velg nye filer som skal lastes opp ved lagring',
            name: 'Nye filer',
        },
        noMessages: 'Ingen meldinger funnet.',
    },
    registerUser: {
        'A user with the provided email address already exists': {
            description: 'En bruker med denne e-postadressen finnes allerede.',
            title: 'Feil oppstod under registrering av bruker.',
        },
        back: 'Tilbake til brukere',
        disabledTooltip:
            'Knappen er deaktivert fordi det ikke er valgt om velkomstmelding skal sendes eller ikke.',
        email: 'E-post',
        firstName: 'Fornavn',
        generalError: {
            description:
                'Registrering feilet. Prøv igjen senere eller ta kontakt med oss så hjelper vi deg.',
            title: 'Feil oppstod under registrering av bruker.',
        },
        lastName: 'Etternavn',
        registerNew: 'Registrer ny bruker',
        registeringUser: 'Registrerer bruker...',
        successNotification: 'Registrering av bruker var vellykket.',
        title: 'Registrer bruker for {{customer}}',
        roles: {
            title: 'Roller',
            superUserCheckBox:
                'Skal ha tilgang til kontrakter og fakturaer (Superbruker)',
        },
        other: {
            title: 'Annet',
            velkomstmelding: 'Skal det sendes velkomstmelding?',
            yesButton: 'Ja',
            noButton: 'Nei',
        },
    },
    sak: {
        actions: {
            Active: 'Åpne sak',
            Closed: 'Lukk sak',
            Deleted: 'Slett sak',
            Merged: 'Slå sammen',
            Postponed: 'Utsett sak',
        },
        addSak: 'Ny sak',
        archivedTasksFor: 'Arkiverte saker for {{kundeName}} ({{kundeNummer}})',
        backButton: 'Tilbake til saksoversikten',
        confirmation: {
            title: 'Henvendelse registrert',
            message:
                'Din henvendelse er registrert. Vi svarer på saken din så fort vi kan.',
        },
        buildingcategory: {
            helperText: 'Velg eiendomskategori',
            name: 'Eiendomskategori',
        },
        category: {
            helperText: 'Velg kategori',
            name: 'Kategori',
        },
        created: 'Opprettet dato',
        dialog: {
            Active: {
                action: 'Ja, åpne',
                description: 'Vil du åpne saken?',
                title: 'Åpne sak',
            },
            Closed: {
                action: 'Ja, lukk',
                description: 'Vil du lukke saken?',
                title: 'Lukk sak',
            },
        },
        emne: 'Emne',
        email: 'E-post',
        emailCopyRecipient: 'Kopi til mottaker:',
        errorDownload: {
            description: 'Noe gikk galt ved lasting av saker.',
            title: 'Noe gikk galt ved lasting av saker.',
        },
        errorNotFound: {
            title: 'Ingen åpne saker funnet.',
        },
        noTasks: 'Ingen saker funnet.',
        goBackToSaker: 'Gå tilbake til sakslisten',
        lukketDato: 'Lukket dato',
        melding: 'Melding',
        meldinger: {
            melding: {
                helperText: 'Skriv ditt svar',
                name: 'Svar',
            },
            noMoreMessages: 'Ikke flere meldinger.',
            sendSvar: 'Send svar',
        },
        myArchivedTasks: 'Mine arkiverte saker',
        myTasks: 'Mine saker',
        openArchive: 'Vis saksarkiv',
        openSakList: 'Vis saksoversikt',
        opprettetAv: 'Opprettet av',
        sakDocuments: {
            helperText:
                'Du kan markere filer for sletting eller laste opp flere filer',
            name: 'Tegninger',
        },
        saksnummer: 'Saksnummer',
        source: 'Kilde',
        sourceDalux: 'Dalux',
        sakImages: {
            helperText:
                'Du kan markere bilder for sletting eller laste opp flere bilder',
            name: 'Bilder',
        },
        sakLukketDato: 'Saken lukket den {{lukketDato}}',
        sakskategori: {
            Administration: 'Administrasjon',
            Sale: 'Salg',
            Support: 'Support',
            title: 'Kategori',
        },
        saksMelding: {
            title: '{{author}} skrev {{date}:',
        },
        sakStatus: {
            Aktiv: 'Aktiv',
            Avsluttet: 'Avsluttet',
            Sammenslått: 'Sammenslått',
            Slettet: 'Slettet',
            Unknown: 'Ukjent',
            Utsatt: 'Utsatt',
            'Venter på 3dje part': 'Venter på 3dje part',
            'Venter på kunde': 'Venter på kunde',
        },
        sakStatusSummary: {
            EjPaborjad: 'Ikke påbegynt',
            Utskriven: 'Utskrevet',
            Utringd: 'Utringet',
            Kvitterad: 'Kvittert',
            Aktiv: 'Aktive',
            Aktiv_1: 'Aktiv',
            Avsluttet: 'Avsluttede',
            Avsluttet_1: 'Avsluttet',
            Sammenslått: 'Sammenslåtte',
            Sammenslått_1: 'Sammenslått',
            Slettet: 'Slettede',
            Slettet_1: 'Slettet',
            Unknown: 'Ukjente',
            Unknown_1: 'Ukjent',
            Utsatt: 'Utsatte',
            Utsatt_1: 'Utsatt',
            'Venter på 3dje part': 'Venter på 3dje part',
            'Venter på 3dje part_1': 'Venter på 3dje part',
            'Venter på kunde': 'Venter på kunde',
            'Venter på kunde_1': 'Venter på kunde',
        },
        savingError: 'Feil under lagring av sak',
        savingSuccess: 'Lagret',
        searchSak: 'Søk etter saker',
        showAll: 'Vis alle meldinger',
        status: 'Status',
        subcategory: {
            helperText: 'Velg underkategori',
            name: 'Underkategori',
        },
        summarytitle: 'Siste saker',
        supportcategory: {
            helperText: 'Velg supportkategori',
            name: 'Supportkategori',
        },
        tasksFor: 'Saker for {{kundeName}} ({{kundeNummer}})',
        vedlegg: {
            title: 'Vedlegg',
        },
    },
    superOffice: {
        issue: {
            new: 'Registrer ny sak',
            status: {
                temporary: 'temporary',
                todo: 'todo',
            },
            title: 'Siste saker',
        },
        langCode: 'no',
        mytasks: 'Mine saker',
        noaccess: 'Du har ikke tilgang til SuperOffice',
        opening: 'Åpner SuperOffice...',
    },
    supportForm: {
        attachments: {
            attachments: 'Last opp vedlegg',
            attachmentsHelperText: 'Velg filene som skal lastes opp',
            title: 'Vedlegg',
        },
        company: {
            companyName: 'Juridisk navn på selskap',
            companyNameHelperText: 'Skriv inn juridisk navn på selskapet',
            orgNumber: 'Organisasjonsnummer',
            orgNumberHelperText: 'Skriv inn organisasjonsnummer',
        },
        contact: 'Kontakt',
        description:
            'Forklaring hvorfor hjelper vi våre leietakere. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur massa libero, eleifend eu erat sed, consequat malesuada lacus. Suspendisse vitae neque ut lacus ultricies blandit. Pellentesque elementum, nulla quis accumsan pellentesque, enim metus sagittis justo, eget pellentesque sapien tortor at odio. Nam nulla orci, pharetra vitae dignissim in, sagittis sit amet neque. Sed sed massa eget arcu scelerisque dapibus. Suspendisse bibendum erat quis lorem maximus dignissim. Vivamus risus tortor, interdum vehicula molestie ut, tempor et felis. Vestibulum aliquam interdum lectus, et interdum lorem gravida eget. Vivamus vulputate placerat nulla, ut consectetur ante rhoncus quis. Fusce sem enim, efficitur vitae ante in, sagittis vulputate dolor. Vivamus nec massa sem. Proin in tincidunt tellus. Nulla eget leo quis nisi cursus congue.',
        economy: 'Statens kompensasjonsordning',
        email: {
            email: 'E-post',
            emailHelperText: 'Skriv inn din e-postadresse',
        },
        governmentSupport: {
            amount: 'Sum',
            amountHelperText: 'Skriv inn summen her',
            caseNumber: 'Saksnummer',
            caseNumberHelperText: 'Skriv inn saksnummeret',
            governmentSupport: 'Har du fått støtte fra staten?',
            governmentSupportExplanation: 'Hvis nei, hvorfor ikke?',
            governmentSupportExplanationHelperText:
                'Fortell gjerne hvorfor du ikke har fått støtten',
            governmentSupportHelperText:
                'Velg om du har fått støtte fra staten',
            month: 'Måned',
        },
        invoice2020Q3: {
            invoiceNumber: 'Fakturanummer Q3 2020',
            invoiceNumberHelperText: 'Skriv inn fakturanummeret for Q3 2020',
        },
        kundeNummer: {
            clientNumber: 'Kundenummer hos KLP',
            clientNumberHelperText: 'Skriv inn kundenummeret hos KLP',
        },
        leietakerinformasjon: 'Leietakerinformasjon',
        other: {
            klpSupportReasonHelperText: 'Skriv din forklaring her',
            klpSupportReasonTitle:
                'Beskriv hvorfor du trenger støtte etter at statens ordning opphører',
            klpSupportReasonTitleShort: 'Begrunnelse',
            title: 'Øvrig',
        },
        personApplying: {
            personName: 'Navn på søker',
            personNameHelperText: 'Skriv inn ditt navn',
        },
        phoneNumber: {
            phoneNumber: 'Telefonnummer',
            phoneNumberHelperText: 'Skriv inn telefonnummer',
        },
        registerForm: 'Registrer søknad',
        revenue: {
            amount: 'Sum',
            amountHelperText: 'Skriv inn summen her',
            month: 'Måned',
            revenue2019: '2019',
            revenue2020: '2020',
            title: 'Omsetningstall',
        },
        shoppingCenter: {
            shoppingCenterHelperText: 'Velg senteret',
            shoppingCenterName: 'Sentertilknytning',
        },
        store: {
            storeName: 'Butikknavn',
            storeNameHelperText: 'Skriv inn butikknavnet',
        },
        support: 'Støtteordning',
        title: 'Søknad om støtte',
    },
    tables: {
        labelRowsPerPage: 'Rader per side:',
    },
    user: {
        myAccount: 'Min konto',
    },
    userSearch: {
        activeUsers: 'Aktive brukere',
        addCustomer: 'Legg til',
        addCustomerError: 'Feil oppstod ved oppdatering av kunder.',
        addCustomerSuccess: 'La til kunde {{customer}}',
        addCustomerTitle: 'Legg til kunde',
        grantAdminError: 'Kunne ikke gi adminrettigheter til {{email}}.',
        grantAdminQuestion: 'Vil du gi adminrettigheter til {{email}}?',
        grantAdminSuccess: 'Ga adminrettigheter til {{email}}.',
        grantSuperUserError:
            'Kunne ikke gi superbrukerrettigheter til {{email}}.',
        grantSuperUserQuestion:
            'Vil du gi superbrukerrettigheter til {{email}}?',
        grantSuperUserSuccess: 'Ga superbrukerrettigheter til {{email}}.',
        grantSuperUserTooltip:
            'Gir eller fjerner tilgang til kontrakt og faktura',
        inActiveUsers: 'Inaktive brukere',
        invitationNotSent: 'Ikke sendt',
        invitationSent: 'Invitasjon sendt',
        invite: 'Inviter',
        inviteActivateUser: 'Inviter/aktiver bruker',
        inviteUserError:
            'Feil oppstod under sending av invitasjon til {{email}}.',
        inviteUserQuestion: 'Vil du sende en invitasjon til {{email}}?',
        inviteUserSuccess: 'Sending av invitasjon til {{email}} var vellykket.',
        refreshingList: 'Oppdaterer listen...',
        removeCustomerError: 'Feil oppstod ved oppdatering av brukeren.',
        removeCustomerQuestion:
            'Vil du fjerne tilgang til kunde {{customer}} for {{email}}?',
        removeCustomerSuccess: 'Fjernet kundetilgang til {{customer}}',
        removeUserSuccess: 'Slettet tilgang til {{user}}',
        removeUserError: 'Kunne ikke slette bruker',
        removeCustomerTitle: 'Fjern kundetilgang',
        removeUserTitle: 'Slett bruker',
        removeUserQuestion: 'Vil du slette bruker {{email}}?',
        remove: 'Fjern',
        revokeAdminError: 'Kunne ikke fjerne adminrettigheter for {{email}}.',
        revokeAdminQuestion: 'Vil du fjerne adminrettigheter for {{email}}?',
        revokeAdminSuccess: 'Fjernet adminrettigheter for {{email}}.',
        revokeSuperUserError:
            'Kunne ikke fjerne superbrukerrettigheter for {{email}}.',
        revokeSuperUserQuestion:
            'Vil du fjerne superbrukerrettigheter for {{email}}?',
        revokeSuperUserSuccess: 'Fjernet superbrukerrettigheter for {{email}}.',
        searchPlaceholder: 'Søk',
        searchResults: 'Søkeresultat ({{count}} treff)',
        searchTitle: 'Søk etter brukere',
        send: 'Send',
        sendNewWelcomeMessage: 'Send ny velkomstmelding',
        sendWelcomeMessageError:
            'Feil oppstod ved sending av velkomstmelding til {{email}}.',
        sendWelcomeMessageQuestion:
            'Vil du sende velkomstmelding til {{email}}?',
        sendWelcomeMessageSuccess:
            'Sending av velkomstmelding til {{email}} var vellykket.',
        userCustomers: 'Kunder',
        userEmail: 'E-post',
        userFirstName: 'Fornavn',
        userIsAdmin: 'Adminbruker',
        userIsSuperUser: 'Superbruker',
        userIsOrdinaryUser: 'Ordinær bruker',
        userLastName: 'Etternavn',
        welcomeMessageSent: 'Velkomstmelding sendt',
        grantSuperUser: 'Gi superbruker-tilgang',
        grantAdminUser: 'Gi adminbruker-tilgang',
        revokeSuperUser: 'Fjern superbruker-tilgang',
        revokeAdminUser: 'Fjern adminbruker-tilgang',
        role: 'Rolle',
        action: 'Handling',
    },
    validator: {
        email: 'Gyldig epost er påkrevd!',
        required: 'Feltet er obligatorisk!',
    },
};
